import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const webinarjam = defineConnector({
  identifier: "webinarjam",
  name: "WebinarJam",
  tagLine: "Webinar hosting",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.webinarjam\\.com/webinarjam/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your WebinarJam API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [WebinarJam](https://www.webinarjam.com/) account and go to the **API** section to copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your WebinarJam account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "b7e2d4f1-8a3c-4e6b-9d5f-1a2b3c4d5e6f",
          helperText: "Your WebinarJam API key.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.webinarjam.com/webinarjam/webinars",
  },
});
